import type { HomepageReviewConceptVariant } from "./components/HomepageReviewConceptHome";

/** Which material a finished preservation cycle left her with. */
export type PostCycleHandoffJourney = "egg" | "embryo" | "sperm";

/**
 * Which of the three preservation journeys a post-cycle Home is about.
 *
 * The closing "decide your next step" card speaks about her eggs, her embryos or
 * her samples by name, and its copy keys are per journey — so the Home that
 * renders it has to say which one. Null on every other Home, which is also what
 * says "this is not a post-cycle Home" to the blocks that ask.
 */
export function resolvePostCycleHandoffJourney(
  variant: HomepageReviewConceptVariant | null | undefined,
): PostCycleHandoffJourney | null {
  switch (variant) {
    case "egg-freezing-postcycle":
      return "egg";
    case "embryo-freezing-postcycle":
      return "embryo";
    case "sperm-freezing-postcycle":
      return "sperm";
    default:
      return null;
  }
}
